module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": ""
    }
  }, [_vm._t("default"), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.cancel) ? _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "error": ""
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('cancel')))])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.save) ? _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "success": ""
    },
    on: {
      "click": _vm.saveClick
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("save")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('save')))])], 1) : _vm._e()], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4b7132c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormContainer.vue
// module id = 1097
// module chunks = 1